export default __webpack_public_path__ + "static/sign-88e6f9b5d33f6ea37847a41a5841e9e2.png";